<template>
  <div class="participant-response__fields-list bg-white edro-section p-20">
    <div class="edro-response-details pb-40" v-for="(res, index) in activityData" :key="index">
      <div v-if="res.activityName == 'Psoriasis Report'">
        <div class="font-weight-bold py-1">Body surface area {{ index + 1 }} : {{ res.bodyPart }}</div>
        <div class="font-weight-bold py-1 font-12">
          Estimation Percentage of body area covered :
          {{ res.estimatePercentage }}
        </div>
        <div class="font-weight-bold py-1 font-12 location-title">Location: {{ res.lesionSide }}</div>
        <div class="d-flex">
          <div class="body-parts-images" v-for="(img, idx) in res.images" :key="idx">
            <div class="image" v-if="preventPIIAccessFromRoles">
              <img @contextmenu.prevent :src="!!img.s3ThumbnailSignedUrl ? img.s3ThumbnailSignedUrl : img.s3SignedUrl" alt="" />
              <div class="image-capture-modal-expand">
                <a class="btn" data-toggle="modal" :data-target="`#${img.imageFileName}-ImgName`"><img @contextmenu.prevent src="static/img/ICN_Fullscreen.svg" alt="" height="20" width="20"/></a>
              </div>
            </div>
            <div class="image" v-else>
              <img @contextmenu.prevent src="static/img/image-blinded.png" alt="" />
            </div>
            <div class="image-filename">{{ img.imageFileName }}</div>
            <div class="modal fade" :id="`${img.imageFileName}-ImgName`" tabindex="-1" role="dialog" aria-labelledby="ImageModalCenterTitle" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered fit-content" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">CLOSE <i class="fa fa-times"></i></span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <img @contextmenu.prevent :src="img.s3SignedUrl" class="enlarged-img" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="res.activityName == 'Target Lesion'">
        <div class="d-flex">
          <div class="body-parts-images" v-for="(img, idx) in res.images" :key="idx">
            <div class="image" v-if="preventPIIAccessFromRoles">
              <img @contextmenu.prevent :src="!!img.s3ThumbnailSignedUrl ? img.s3ThumbnailSignedUrl : img.s3SignedUrl" alt="" />
              <div class="image-capture-modal-expand">
                <a class="btn" data-toggle="modal" :data-target="`#${img.imageFileName}-ImgName`"><img @contextmenu.prevent src="static/img/ICN_Fullscreen.svg" alt="" height="20" width="20"/></a>
              </div>
            </div>
            <div class="image" v-else>
              <img @contextmenu.prevent src="static/img/image-blinded.png" alt="" />
            </div>
            <div class="image-filename">{{ img.imageFileName }}</div>
            <div class="modal fade" :id="`${img.imageFileName}-ImgName`" tabindex="-1" role="dialog" aria-labelledby="ImageModalCenterTitle" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered fit-content" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">CLOSE <i class="fa fa-times"></i></span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <img @contextmenu.prevent :src="img.s3SignedUrl" class="enlarged-img" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="activityData.length < 0">
      No Data Availabile
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { AclRule } from "vue-acl";
import { BSTAT, CRA, DM, HOME_HEALTH, PHV, PI, QUALITY, STUDY_ADMIN, STUDY_MANAGER, SYSTEM_ADMIN, CraUB, SUPPORT } from "@/constants/authRoles";

export default {
  props: ["activityData"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyManagerAccess() {
      this.$acl.change(`${STUDY_MANAGER}`);
      return this.$acl.check("userAccess");
    },
    canCraAccess() {
      this.$acl.change(`${CRA}`);
      return this.$acl.check("userAccess");
    },
    canDmAccess() {
      this.$acl.change(`${DM}`);
      return this.$acl.check("userAccess");
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canQualityAccess() {
      this.$acl.change(`${QUALITY}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    canBioStatisticsAccess() {
      this.$acl.change(`${BSTAT}`);
      return this.$acl.check("userAccess");
    },
    canPharmacovigilanceAccess() {
      this.$acl.change(`${PHV}`);
      return this.$acl.check("userAccess");
    },
    canCraUBAccess() {
      this.$acl.change(`${CraUB}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    },
    preventPIIAccessFromRoles() {
      const roles = this.canSysAdminAccess || this.canStudyAdminAccess || this.canStudyManagerAccess || this.canCraAccess || this.canDmAccess || this.canQualityAccess || this.canBioStatisticsAccess || this.canPharmacovigilanceAccess || this.canCraUBAccess || this.canSupportAccess;
      return !roles;
    }
  }
};
</script>
<style lang="scss">
.edro-section {
  .body-parts-images {
    position: relative;
    .image {
      width: 250px;
      height: 250px;
      margin-right: 30px;
      text-align: center;
      background: #0d0c0c;
      img {
        width: auto;
        height: 100%;
      }
    }
    .image-filename {
      font-weight: bold;
      margin-top: 13px;
      width: 250px;
      word-wrap: break-word;
    }
  }
  .image-capture-modal-expand {
    position: absolute;
    right: 36px;
    top: 205px;
    background-color: #d7dfeb;
    border-radius: 3px;
  }

  .modal-content {
    background-color: transparent !important;
    border: none !important;
  }

  .modal-header {
    border: none !important;
    padding: 0 !important;
  }
  .close {
    background-color: transparent !important;
    border: 0 !important;
    color: #fff !important;
    font-family: Roboto !important;
    font-size: 14px !important;
    font-weight: normal !important;
    text-shadow: inherit;
    opacity: 1;
  }

  .modal-body {
    border: none !important;
    padding: 0 !important;
    .enlarged-img {
      width: auto;
      height: 90vh;
    }
  }
}
.location-title {
  text-transform: capitalize;
}
.fit-content {
  max-width: fit-content !important;
}
</style>
